const DateInput = ({selectedDate, handleSelectedDate, disabled = false}) => {
  return (
    <input
        disabled={disabled}
        type="date"
        id="date"
        className="choice-input"
        value={selectedDate}
        onChange={handleSelectedDate}  
    />
  );
};

export default DateInput;
